import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";

import { useShowAlert } from "../../../context/AlertContext";
import handleError from "../../../constants/handleError";

import { useAuth } from "../../../context/AuthProvider";

const AccessStore = () => {
    const { handleLogin } = useAuth();
    const { atoken, rtoken } = useParams();
    const [isPreLoading, setPreLoading] = useState(false);
    const [isPreText, setPreText] = useState("Your invitation is currently being processed...");
    const showAlert = useShowAlert();
    
    const handleInvite = async (atoken, rtoken) => {
        setPreLoading(true);
        try {
            var tokens = {
                accessToken: atoken,
                refreshToken: rtoken
            }
            handleLogin(tokens);
            window.location.href = "/dashboard";
        } catch (error) {
            handleError(error, showAlert);
            return false;
        } finally {
            setPreLoading(false);
        }
    }

    useEffect(() => {
        handleInvite(atoken, rtoken);
    }, [atoken, rtoken]);

    return (
        <div className="wrapper">
            <div className="authentication-forgot d-flex align-items-center justify-content-center">
                <div className="card forgot-box">
                    <div className="card-body">
                        <div className="p-3 text-center">
                            <div className="text-center mb-3">
                                <img src="/assets/images/logo-icon.png" width="60" alt="Login" />
                            </div>
                            <h4 className="mt-3 font-weight-bold">Accessing</h4>
                            {isPreLoading ? (
                                <p className="text-muted">Your access is authenticating...</p>
                            ) : (
                                <>
                                    <p className="text-muted mb-0">{isPreText}</p>
                                </>
                            )}
                            <div className="d-grid gap-2">
                                {isPreLoading ? (
                                    <button className="btn btn-primary pb-0 text-right" disabled>
                                        <CircularProgress size={22} className="text-white" />
                                    </button>
                                ) : ("")}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccessStore;